import React from 'react';
import NewsIconWrapper from './NewsIconWrapper';

export default function PromoMaterials(props) {
  return (
    <NewsIconWrapper {...props}>
      <circle cx="16" cy="16" r="16" fill="#BBEBFA"/>
      <path d="M24.6667 19.6667V9.66667C24.6667 8.75 23.9167 8 23 8H13C12.0833 8 11.3333 8.75 11.3333 9.66667V19.6667C11.3333 20.5833 12.0833 21.3333 13 21.3333H23C23.9167 21.3333 24.6667 20.5833 24.6667 19.6667ZM15.5 16.3333L17.1917 18.5917L19.6667 15.5L23 19.6667H13L15.5 16.3333ZM8 11.3333V23C8 23.9167 8.75 24.6667 9.66667 24.6667H21.3333V23H9.66667V11.3333H8Z" fill="#5A5A5A"/>
    </NewsIconWrapper>
  );
}
